/* eslint-disable react/no-danger */
/* eslint-disable max-len */
import React from 'react';

export default function New() {
  return (
    <svg
      className="new-list"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="20px"
      height="20px"
      viewBox="0 0 20 20"
      style={{ enableBackground: 'new 0 0 20 20' }}
      xmlSpace="preserve"
    >
      <title>New</title>
      <path d="M17.6,19.6H2.4V0.4h9.9l5.4,5.4V19.6z M3.6,18.4h12.8V6.3l-4.6-4.6H3.6V18.4z" />
      <path className="st0" d="M17,6" />
      <path className="st0" d="M12,6" />
      <polygon points="17.5,7 10.8,7 10.8,0.4 12,0.4 12,5.7 17.5,5.7 " />
      <rect x="7" y="10.3" width="6" height="1.2" />
      <rect x="9.3" y="8.1" width="1.2" height="5.9" />
    </svg>
  );
}
